import { ApolloLink } from "@apollo/client/link/core";

// Middleware to inject x-tod-lsn into headers
const lsnLink = new ApolloLink((operation, forward) => {
  const xTodLsn = localStorage.getItem("x-tod-lsn");

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...(xTodLsn ? { "x-tod-lsn": xTodLsn } : {}), // Include only if value exists
      ...headers,
    },
  }));

  // Update x-tod-lsn from response headers and Forward the operation to the next link
  return forward(operation).map(data => {
    const context = operation.getContext();
    const {
      response: { headers },
    } = context;

    if (headers) {
      const xTodLsn = headers.get("x-tod-lsn");
      if (xTodLsn) {
        localStorage.setItem("x-tod-lsn", xTodLsn);
      }
    }

    return data;
  });
});

export default lsnLink;
